import { PostInterface } from 'modules/community/types/post-interface'
import { PostPinnedToType } from 'modules/community/types/post-pinned-to-type'

export const getPostMutationKey = (target: PostPinnedToType) =>
  target === 'community' ? 'posts' : 'topic-posts'

export const isPinnedIn = (post: PostInterface, source: PostPinnedToType) =>
  post.pinnedTo.some(pinnedTo => pinnedTo === source)
